<template>
  <span class="inline-flex items-center gap-1">
    <span>{{ formattedAmount }}</span>
    <button
      v-if="isAmended"
      v-tooltip.top="tooltipText"
      type="button"
      class="inline-flex items-center border-0 bg-transparent p-0 text-gray-400 cursor-help"
      :aria-label="tooltipText"
      @click.stop
      @mousedown.stop
    >
      <i class="pi pi-info-circle" aria-hidden="true" />
    </button>
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { getFormattedCurrency } from "@/shared/utils/helpers";

interface Props {
  amount: number | string;
  isAmended?: boolean;
  originalAmount?: number | string | null;
}

const props = withDefaults(defineProps<Props>(), {
  isAmended: false,
  originalAmount: null,
});

const toNumber = (v: number | string | null | undefined): number => {
  if (v === null || v === undefined) return 0;
  if (typeof v === "number") return v;
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : 0;
};

const formattedAmount = computed(() =>
  getFormattedCurrency(toNumber(props.amount))
);

const tooltipText = computed(() => {
  if (props.originalAmount === null || props.originalAmount === undefined) {
    return "This payment was amended.";
  }
  return `Amended from ${getFormattedCurrency(toNumber(props.originalAmount))}.`;
});
</script>
